import { ShuttleInformationService } from './shuttle-information.service';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'shuttleInformation'
})
export class ShuttleInformationPipe implements PipeTransform {

  constructor(private shuttleInformationService: ShuttleInformationService) {
  }

  transform(code: number, args?: any): string {
    if (!code || code === 0 || code === 8) {
      return '';
    }

    const shuttleDescription = this.shuttleInformationService.getShuttleInfo(code);
    return shuttleDescription && shuttleDescription.name;
  }
}
